<template>
  <div v-if="filter.field != null" class="form-group row filter-row">
    <!--    <div class="col-md-12">{{filter}}</div>-->
    <div class="col-md-3 field">
      <!--      {{field}}-->
      <select v-model="field" @change="loadFieldValues" class="form-control styled-input"
              name=""
              :id="'field-'+i">
        <option selected disabled value="">-- {{ $t('message.choose_a_field') }} --</option>
        <option disabled value="">-- {{ $t('message.team_fields') }}</option>
        <template v-for="field in teamFields">
          <option :value="field.key">{{field.label}}</option>
        </template>
        <option disabled value="">-- {{ $t('message.user_fields') }}</option>
        <template v-for="field in userFields">
          <option :value="field.key">{{field.label}}</option>
        </template>
      </select>
    </div>
    <div class="col-md-3 operator">
      <select v-model="operator" class="form-control styled-input" name="" :id="'operator-'+i">
        <option selected disabled value="">-- {{ $t('message.operator') }} --</option>
        <template v-for="operator in operatorTypes">
          <option :value="operator.key">{{operator.label}}</option>
        </template>
      </select>
    </div>
    <div class="col value filter-row">
      <template v-if="selectedField.type === 'select'">
        <select v-model="value" class="form-control styled-input" :name="'value-'+i" :id="'value-'+i">
          <option disabled value="">-- {{ $t('message.value') }} --</option>
          <template v-for="option in selectedField.options">
            <option :value="option.key">{{option.label}}</option>
          </template>
        </select>
      </template>

      <template v-else>
        <input v-model="value"
               :name="'value-'+i"
               :type="selectedField.type"
               :placeholder="$t('message.value')"
               :class="selectedField.type === 'date' ? 'hidden' : 'not-date'"
               class="form-control styled-input value_field">
      </template>

    </div>
    <div class="ml-auto col-auto logic">

      <div class="form-row">
        <select :disabled="last" v-model="logic" :class="last ? 'disabled' : ''"
                class="form-control styled-input w-auto" name="" :id="'logic-'+i">
          <option value="and">{{ $t('message.and') }}</option>
          <option value="or">{{ $t('message.or') }}</option>
          <option value="not">{{ $t('message.not') }}</option>
        </select>
        <button :data-index="i" @click.prevent="removeRow(i)" class="mb-2 btn btn-default">
          <i class="fal fa-times"></i>
        </button>

      </div>
    </div>
  </div>
</template>

<script>

  import store from "../../store/store";
  import moment from "moment";
  import flatpickr from "flatpickr";

  export default {
    methods: {

      loadFieldValues(e) {
        //  console.log('loading field', e.target.value)
        let selectedField = e.target.value;
        this.value = '';
        this.operatorTypes = this.userFields[selectedField].operators;
        this.selectedField = this.userFields[selectedField] ? this.userFields[selectedField] : this.teamFields[selectedField]
      },
      removeRow() {
        this.$emit('removeRow')
        this.field = '',
          this.operator = '',
          this.value = '',
          this.logic = '',
          this.filter.field = null;

      },
      updateStoreFilter() {
        let dispatch = {
          i: this.i,
          field: this.field,
          operator: this.operator,
          value: this.value,
          logic: this.logic,
        };
        if (dispatch.field && dispatch.operator && dispatch.value && dispatch.logic) {
          //  console.log('updating filter', dispatch)
          // store.dispatch('addFilter', dispatch);
          store.dispatch('addFilter', dispatch);
        }
      },
    },
    mounted() {
      this.filter = this.filterData;
      this.value = this.filter.value;
      this.field = this.filter.field;
      this.logic = this.filter.logic;
      this.operator = this.filter.operator;
    },
    beforeDestroy() {
      this.field = '';
      this.operator = '';
      this.value = '';
      this.logic = '';
    },

    data() {
      return {
        filter: this.filterData,
        field: '',
        operator: '',
        value: '',
        logic: 'and',
        selectedField: {type: 'text'},
        store,
        operatorTypes: [
          {
            key: 'equals',
            label: this.$t('message.equals'),
          },
          {
            key: 'noequals',
            label: this.$t('message.does_not_equal'),
          },
          {
            key: 'contains',
            label: this.$t('message.contains'),
          },
          {
            key: 'nocontain',
            label: this.$t('message.does_not_contain'),
          },
          {
            key: 'less',
            label: this.$t('message.is_less_than'),
          },
          {
            key: 'more',
            label: this.$t('message.is_more_than'),
          },
          {
            key: 'distance',
            label: this.$t('message.is_near'),
          }
        ],
        userFields: {
          role: {
            key: 'role',
            label: this.$t('message.role'),
            type: 'select',
            options: [{key: '1', label: this.$t('message.user')},
              {key: '3', label: this.$t('message.hr')},],
            operators: [
              {
                key: 'equals',
                label: this.$t('message.equals'),
              },
              {
                key: 'noequals',
                label: this.$t('message.does_not_equal'),
              },
            ]
          },
          average: {
            key: 'average',
            label: this.$t('message.score'),
            type: 'select', options: [
              {key: '1', label: '1'},
              {key: '2', label: '2'},
              {key: '3', label: '3'},
              {key: '4', label: '4'},
              {key: '5', label: '5'},
              {
                key: 'ts',
                label: this.$t('message.team_score'),
              },
              {
                key: 'cs',
                label: this.$t('message.company_score'),
              },
            ],
            operators: [
              {
                key: 'equals',
                label: this.$t('message.equals')
              },
              {
                key: 'less',
                label: this.$t('message.is_less_than')
              },
              {
                key: 'more',
                label: this.$t('message.is_more_than')
              },
            ]
          },
          median: {
            key: 'median',
            label: this.$t('message.median'),
            type: 'select',
            options: [
              {key: '1', label: '1'},
              {key: '2', label: '2'},
              {key: '3', label: '3'},
              {key: '4', label: '4'},
              {key: '5', label: '5'},
              {key: 'ts', label: this.$t('message.team_score')},
              {
                key: 'cs', label: this.$t('message.team_score')
              },],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          lowest: {
            key: 'lowest',
            label: this.$t('message.lowest'),
            type:
              'select', options:
              [
                {key: '1', label: '1'},
                {key: '2', label: '2'},
                {key: '3', label: '3'},
                {key: '4', label: '4'},
                {key: '5', label: '5'},
                {key: 'ts', label: this.$t('message.team_score')},
                {
                  key: 'cs', label: this.$t('message.team_score')
                },],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          highest: {
            key: 'highest', label:
              this.$t('message.highest'), type:
              'select', options:
              [
                {key: '1', label: '1'},
                {key: '2', label: '2'},
                {key: '3', label: '3'},
                {key: '4', label: '4'},
                {key: '5', label: '5'},
                {key: 'ts', label: this.$t('message.team_score')},
                {
                  key: 'cs', label: this.$t('message.team_score')
                },],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},

              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          firstname: {
            key: 'firstname', label:
              this.$t('message.first_name'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'contains', label: this.$t('message.contains')},
              {key: 'nocontain', label: this.$t('message.does_not_contain')},
            ]
          },
          lastname: {
            key: 'lastname', label:
              this.$t('message.last_name'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'contains', label: this.$t('message.contains')},
              {key: 'nocontain', label: this.$t('message.does_not_contain')},
            ]
          },
          zipcode: {
            key: 'zipcode', label:
              this.$t('message.zip_postal_code'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'contains', label: this.$t('message.contains')},
              {key: 'nocontain', label: this.$t('message.does_not_contain')},
            ]
          },
          country: {
            key: 'country', label:
              this.$t('message.country'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
            ]
          },
          // stateprovince: {
          //   key: 'stateprovince', label:
          //     this.$t('message.state_province'), type:
          //     'text',
          //   options: [],
          //   operators: [
          //     {key: 'equals', label: this.$t('message.equals')},
          //     {key: 'noequals', label: this.$t('message.does_not_equal')},
          //   ]
          // },
          city: {
            key: 'city', label:
              this.$t('message.city'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
            ]
          },
          // geocode: { todo:
          //   key: 'geocode', label:
          //     'Location', type:
          //     'text',
          //   options: [],
          //   operators: [
          //     {key: 'less', label: this.$t('message.is_less_than')},
          //     {key: 'more', label: this.$t('message.is_more_than')},
          //   ]
          // },
          birthdate: {
            key: 'birthdate', label:
              this.$t('message.age'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          employmentstart: {
            key: 'employmentstart',
            label: this.$t('message.start_of_employment'),
            type: 'date',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          employmentend: {
            key: 'employmentend',
            label: this.$t('message.end_of_employment'),
            type: 'date',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          terminationreason: {
            key: 'terminationreason', label:
              this.$t('message.reason_for_termination'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'contains', label: this.$t('message.contains')},
              {key: 'nocontain', label: this.$t('message.does_not_contain')},
            ]
          },
          gender: {
            key: 'gender', label:
              this.$t('message.gender'), type:
              'select', options:
              [
                {key: 'm', label: 'male'},
                {key: 'f', label: 'female'},
                {
                  key: 'x', label: 'other'
                },],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
            ]
          },
          jobtitle: {
            key: 'jobtitle', label:
              this.$t('message.title'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'contains', label: this.$t('message.contains')},
              {key: 'nocontain', label: this.$t('message.does_not_contain')},
            ]
          },
          seniority: {
            key: 'seniority', label:
              this.$t('message.seniority'), type:
              'select', options:
              [
                {key: 'j', label: 'junior'},
                {key: 'm', label: 'medior'},
                {key: 's', label: 'senior'},],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
            ]
          },
          degreelevel: {
            key: 'degreelevel', label:
              this.$t('message.degree'), type:
              'select', options:
              [
                {key: 'primary', label: this.$t('message.primary')},
                {key: 'secondary', label: this.$t('message.secondary')},
                {key: 'bachelor', label: this.$t('message.bachelor')},
                {key: 'master', label: this.$t('message.master')},
                {key: 'doctorate', label: this.$t('message.doctorate')},],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          maritalstatus: {
            key: 'maritalstatus',
            label: this.$t('message.marital_state'),
            type: 'select',
            options:
              [
                {key: 'notmarried', label: this.$t('message.not_married')},
                {key: 'married', label: this.$t('message.married')},
                {key: 'divorced', label: this.$t('message.divorced')},
                {
                  key: 'widowed', label: this.$t('message.widowed')
                },],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
            ]
          },
          modeoftransport: {
            key: 'modeoftransport', label:
              this.$t('message.mode_of_transport'), type:
              'select', options:
              [
                {key: 'foot', label: this.$t('message.foot')},
                {key: 'bike', label: this.$t('message.bike')},
                {key: 'public', label: this.$t('message.public_transportation')},
                {
                  key: 'car', label: this.$t('message.car')
                },],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
            ]
          },
          children: {
            key: 'children', label:
              this.$t('message.children'), type:
              'text',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          perks: {
            key: 'perks', label:
              this.$t('message.perks'), type:
              'select', options: this.perks,
            operators: [
              {key: 'contains', label: this.$t('message.contains')},
              {key: 'nocontain', label: this.$t('message.does_not_contain')},
            ]
          },
          tags: {
            key: 'tags', label:
              this.$t('message.tags'), type:
              'select',
            options: this.tags,
            operators: [
              {key: 'contains', label: this.$t('message.contains')},
              {key: 'nocontain', label: this.$t('message.does_not_contain')},
            ]
          },
          avgscore_difference_team: {
            key: 'avgscore_difference_team', label:
              this.$t('message.score_difference_from_team'), type:
              'number',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
          avgscore_difference_company: {
            key: 'avgscore_difference_company', label:
              this.$t('message.score_difference_from_company'), type:
              'number',
            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
        },
        teamFields: {
          avgscore_difference_company: {
            key: 'avgscore_difference_company',
            label: this.$t('message.score_difference_from_company'),
            type: 'number',

            options: [],
            operators: [
              {key: 'equals', label: this.$t('message.equals')},
              {key: 'noequals', label: this.$t('message.does_not_equal')},
              {key: 'less', label: this.$t('message.is_less_than')},
              {key: 'more', label: this.$t('message.is_more_than')},
            ]
          },
        },
        fp: {},
      }
    },
    watch: {
      selectedField() {
        if (!this.isEmptyObject(this.fp)) {
          this.fp.destroy()
          this.fp = {}
        }
        if (this.selectedField.type === 'date') {
          let options = {
            altInput: true,
            altFormat: "d/m/Y",
            maxDate: moment().format('YYYY-MM-DD')
          };

          const el = this.$el.querySelector('.value_field');
          //  console.log('change field', el)
          //
          // el.classList.add('hidden');

          this.fp = flatpickr(el,
            options
          );
        }

      },
      filterData() {
        this.filter = this.filterData;
        this.value = this.filter.value;
        this.field = this.filter.field;
        this.logic = this.filter.logic;
        this.operator = this.filter.operator;
      },
      field() {
        this.updateStoreFilter()
      },
      operator() {
        this.updateStoreFilter()
      },
      value() {
        this.updateStoreFilter()
      },
      logic() {
        this.updateStoreFilter()
      },
    },
    props: {
      last: {
        type: Boolean,
        default() {
          return false
        }
      },
      perks: {
        type: Array,
        default() {
          return []
        }
      },
      tags: {
        type: Array,
        default() {
          return []
        }
      },
      i: {
        type: Number,
        default() {
          return 0
        }
      },
      filterData: {
        type: Object,
        default() {
          return {
            field: '',
            operator: '',
            value: '',
            logic: 'and'
          }
        }
      }
    }
  }
</script>
<style>
  .team-overview-filter .form-control.disabled {
    opacity: .25;
    cursor: not-allowed;
  }

  .filter-row.value input[type="date"] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tree/CompanyTreeFilterRow.vue